import { Profile } from '@bp/bp-graphql-types';

type Mappings<T, K extends keyof T, P extends string = never> = K | P;

export type StudentMapping = Mappings<
  Profile,
  | 'salutation'
  | 'title'
  | 'lastName'
  | 'firstName'
  | 'firstNames'
  | 'prefixName'
  | 'shortName'
  | 'email'
  | 'birthday'
  | 'address1'
  // | 'organizationRoles'
  | 'foreignRefId',
  'grade' | 'gradeGroup' | 'gradeAndGradeGroup' | 'profileUuid' | 'classUuid'
>;

export const studentMappingOptions = [
  'salutation',
  'title',
  'lastName',
  'firstName',
  'firstNames',
  'prefixName',
  'shortName',
  'email',
  'birthday',
  'address1',
  // 'organizationRoles',
  'foreignRefId',
  'grade',
  'gradeGroup',
  'gradeAndGradeGroup',
] as const;

// TODO: something like this to handle mandatory fields at one place
export const mandatoryStudentMappingOptions: StudentMapping[] = ['firstName', 'lastName', 'foreignRefId'] as const;

export type StudenMappingSelectType = {
  label: string;
  value: StudentMapping;
};

export type XlsxFileImport = {
  title: string;
  headers: string[];
  rows: (string | null)[][];
};

export type XlsxImportColumn<T extends StudentMapping> = { content: T; index: number | null };

export type XlsxImportEntry<T extends StudentMapping> = Record<T, string | null> & {
  rowIndex: number;
  connectProfileUuid: string | null;
  ignore: T[];
};
